module.exports = __webpack_public_path__ + "2bff0b8aae8eccb61b82e4d97b779357.pdf";